<!-- GlobalLoading.vue -->
<template>
    <div v-if="isVisible" class="loading-overlay">
      <Vue3Lottie :animationData="animationData" :width="300" :height="300" :speed="2" loop autoplay />
    </div>
  </template>
  
  <script>
  import { Vue3Lottie } from 'vue3-lottie'
  import animation from '@/assets/loader.json'
  import { globalLoadingState } from '@/plugins/loading'
  
  export default {
    components: { Vue3Lottie },
    computed: {
      isVisible() {
        return globalLoadingState.visible
      },
      animationData() {
        return animation
      }
    }
  }
  </script>
  
  <style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  </style>
  